<script setup lang="ts">
  import {
    computed,
    nextTick,
    onActivated,
    onBeforeUnmount,
    onMounted,
    reactive,
    ref,
    watch,
  } from 'vue';
  import {
    actions as actionTypes,
    useUserComponent,
    userComponentProps,
    useHelpers,
    createComponentScope,
    Resource,
    uniqueID,
  } from '@integro/core';
  import type { IAppHelpers } from '@integro/core';
  import * as _ from 'lodash';

  defineOptions({
    name: 'FieldsetProjectGeneral',
  });

  const componentMetadata = {
    kind: 'usercontrol',
  };

  const emit = defineEmits(['reload', 'close', 'save']);

  const props = defineProps({
    ...userComponentProps,
    project: {
      type: Object,
      required: true,
    },
  });

  const {
    $app,
    $fn,
    $i18n,
    $store,
    $config,
    $imodal,
    $notification,
    $tabs,
    $route,
    $router,
    gettext,
    pgettext,
    ngettext,
    npgettext,
    schemaDefaults,
    getSchema,
    searchDataSource,
    randomElementId,
    datetime,
    date,
    time,
    number,
    money,
    distance,
    username,
    filesize,
  } = useHelpers();

  const labelAlign = ref('right');
  const ux = ref([]);

  const $data = computed(() => ({
    labelAlign: labelAlign.value,
    ux: ux.value,
  }));

  const {
    loading,
    error,
    loaded,
    reloading,
    showLoadingIndicator,
    loadDataThrottled,
    friendlyName,
    loadData,
    touchLastLoaded,
    handleError,
    setData,
    forms,
    registerForm,
    unregisterForm,
    canLoadData,
    isModalComponent,
    modalName,
    pageDocument: _pageDocument,
    routeTab,
    ux: _ux,
    componentMetadata: _componentMetadata,
    $uid,
    lastLoaded,
  } = useUserComponent(props, {
    metadata: componentMetadata,
    dataSpecs: [{ name: 'labelAlign' }, { name: 'ux' }],
    loaders: {},
    ux: {},
    dataRefs: { labelAlign, ux },
  });

  const $component = createComponentScope(
    {
      $app,
      $fn,
      $i18n,
      $store,
      $imodal,
      $notification,
      $tabs,
      $router,
    } as IAppHelpers,
    {
      emit,
      forms,
      error,
      isModalComponent,
      modalName,
      componentMetadata,
      loadData,
      registerForm,
      unregisterForm,
      setData,
      touchLastLoaded,
      handleError,
    }
  );

  watch(
    () => props.project,
    (newValue, oldValue) => {
      if (_.isEqual(newValue, oldValue)) return;
      loadDataThrottled('project');
    }
  );

  const act_7315092382398562_reloadComponentData_pwe60eqyb =
    new actionTypes.ReloadComponentDataAction({});
  const inst_evh_7315092382398562_reload_om667gaxq =
    new actionTypes.EventHandlerImpl({
      action: act_7315092382398562_reloadComponentData_pwe60eqyb,
      event: 'reload',
      displayName: 'reloadComponentData',
    });
  const inst_evh_7315092382398562_reload = new actionTypes.EventHandlerGroup({
    handlers: [inst_evh_7315092382398562_reload_om667gaxq],
    event: 'reload',
  });

  const actions = {
    inst_evh_7315092382398562_reload_om667gaxq,
    inst_evh_7315092382398562_reload,
  };

  const evh_7315092382398562_reload_om667gaxq = async (event, scope) => {
    return await actions.inst_evh_7315092382398562_reload_om667gaxq.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_7315092382398562_reload = async (event, scope) => {
    return await actions.inst_evh_7315092382398562_reload.executeFromDOM(
      $component,
      event,
      scope
    );
  };

  defineExpose({
    loadData,
    loading,
    loaded,
    error,
  });
</script>

<template>
  <ItpUsercontrol
    :loading="loading"
    :reloading="reloading"
    :loaded="loaded"
    :error="error"
    @reload="evh_7315092382398562_reload($event, {})"
  >
    <ItpFormGroup
      :label-cols-md="4"
      :content-cols-md="8"
      name="name"
      :label="pgettext('Project', 'Name')"
      :labelAlign="labelAlign"
      required
    >
      <ItpFormInput name="name" v-model="project.name" required> </ItpFormInput>
    </ItpFormGroup>
    <ItpFormGroup
      :label-cols-md="4"
      :content-cols-md="8"
      name="code"
      :label="pgettext('Project', 'Code')"
      :labelAlign="labelAlign"
      required
    >
      <ItpFormInput name="code" v-model="project.code" required> </ItpFormInput>
    </ItpFormGroup>
  </ItpUsercontrol>
</template>
